<template>
  <no-page-list ref='pageList' request-url="/platform/supplier/list" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px"
                 :ref="'row'+row.id" @click.stop="()=>{
          $router.push({name:'purchaseRecordList',params: {supplierId:row.id}})
        }">
          <van-col span="24">商家名称: {{row.supplierName}}</van-col>
          <van-col span="12">待支付金额: {{row.unpaidAmount}}</van-col>
          <van-col span="12">已支付金额: {{row.paidAmount}}</van-col>
        </van-row>
      </template>
    </no-page-list>
</template>

<script>
import NoPageList from '@/components/tools/NoPageList'
export default {
  name: 'SupplierList',
  components: { NoPageList },
  created () {
  },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
